module.exports = __webpack_public_path__ + "static/assets/780de411d1edba8c02b28080fd054c35.png";